import React from "react";

export default function ExportUserToCsvButton({
  data = [],
  filename = "export.csv",
  disabled = false,
}) {
  const handleExport = () => {
    if (!data || data.length === 0) return;

    const headers = [
      "Name",
      "Cust ID",
      "Group",
      "Disabled",
      "Comment",
      "Updated At",
    ];

    const csvContent = [
      headers.join(","),
      ...data.map((r) =>
        [
          `"${r.name || ""}"`,
          `"${r.cust_id || ""}"`,
          `"${r.group_name || ""}"`,
          r.disabled ? "Yes" : "No",
          `"${(r.comment || "").replace(/"/g, '""')}"`,
          `"${r.updated_at || ""}"`,
        ].join(",")
      ),
    ].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <button
      onClick={handleExport}
      disabled={disabled || data.length === 0}
      className="
    ml-auto
    px-4 py-2 rounded
    bg-blue-600 text-white
    hover:bg-blue-700
    disabled:opacity-50
    disabled:cursor-not-allowed
  "
    >
      Export CSV
    </button>
  );
}
